import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function PlanetScrubsLanding() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showSubscribe, setShowSubscribe] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);



  useEffect(() => {
    const dismissedAt = localStorage.getItem('popupDismissedAt');

    // Check if it's been less than 24 hours
    if (!dismissedAt || (Date.now() - parseInt(dismissedAt, 10)) > 24 * 60 * 60 * 1000) {
      const timer = setTimeout(() => {
        setShowSubscribe(true);
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, []);


  useEffect(() => {
    const anchors = document.querySelectorAll('a[href^="#"]');
    const smoothScroll = (e) => {
      e.preventDefault();
      const target = document.querySelector(e.currentTarget.getAttribute('href'));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    };

    anchors.forEach(anchor => anchor.addEventListener('click', smoothScroll));

    return () => {
      anchors.forEach(anchor => anchor.removeEventListener('click', smoothScroll));
    };
  }, []);

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setIsReady(true), 100); // Let layout settle
    return () => clearTimeout(timeout);
  }, []);

  const [slidePercentage, setSlidePercentage] = useState(33.3);

  useEffect(() => {
    const updateSlidePercentage = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setSlidePercentage(100);  // Show ~1.25 slides on small screens
      } else if (width < 1024) {
        setSlidePercentage(33.3);  // 3 slides
      } else {
        setSlidePercentage(20); // 5 slides
      }
    };

    updateSlidePercentage(); // initial
    window.addEventListener('resize', updateSlidePercentage);
    return () => window.removeEventListener('resize', updateSlidePercentage);
  }, []);

  return (
    <div className="bg-white text-gray-800 font-poppins">
      {/* Header */}
      <header className="text-center py-6 border-b border-gray-200">
        <img src="/img/logo/planet-scrubs-logo-new.png" alt="Planet Scrubs Logo" className="mx-auto w-1/2 max-w-md" />
        <nav className="mt-1 relative sm:mt-4">
          {/* Hamburger button (mobile only) */}
          <button
            className="sm:hidden text-pink-500 text-3xl focus:outline-none absolute top-[-1.5rem] right-4 z-20"
            onClick={() => setMenuOpen(prev => !prev)}
            aria-label="Toggle menu"
          >
            &#9776;
          </button>

          {/* Menu */}
          <ul className={`flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6 font-medium text-lg text-pink-500 transition-all duration-300 
    ${menuOpen ? 'block' : 'hidden'} sm:flex`}
          >

            <li><a href="#about" className="font-sans hover:text-blue-500 transition">About</a></li>
            <li><a href="#location" className="font-sans hover:text-blue-500 transition">Location</a></li>
            <li><a href="#hours" className="font-sans hover:text-blue-500 transition">Store Hours</a></li>
            <li><a href="#contact" className="font-sans hover:text-blue-500 transition">Contact</a></li>
            <li>
              <a href="https://www.planetscrubs-cherokee.com/" target="_blank" rel="noopener noreferrer" className="font-sans hover:text-blue-500 transition">
                Shop
              </a>
            </li>
          </ul>
        </nav>

      </header>

      {/* Carousel */}
      <section className="py-4 sm:py-8 px-6 ...">
        <div className="max-w-5xl mx-auto">
          <Carousel
            centerMode
            centerSlidePercentage={slidePercentage}
            autoPlay={isReady}
            infiniteLoop
            selectedItem={0}
            interval={2500}
            showThumbs={false}
            showStatus={false}
            showArrows={false}
            showIndicators={false}
          >
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/koi.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/dickies-medical.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/greys-anatomy.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/healing-hands.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/ava-therese.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/roth-wear.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/cherokee.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/landau.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/wonder-wink.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/skechers.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/carhartt.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="h-24 w-40 flex items-center justify-center mx-auto">
              <img src="/img/brands/medcouture.png" alt="" className="max-h-full max-w-full object-contain" />
            </div>



          </Carousel>

        </div>
      </section>

      {/* About */}
      <section id="about" className="bg-white py-8 px-6 max-w-screen-md mx-auto">
        <h2 className="text-2xl text-blue-500 font-poppins mb-4">About Us</h2>
        <p className="text-gray-700 text-lg font-sans">
          Serving the Dallas–Fort Worth area since 2006, Planet Scrubs provides medical professionals with a curated selection of scrubs, lab coats, footwear, and accessories. We carry top brands in a wide range of sizes and styles — including options for men and women — and offer custom embroidery for a personal touch.
        </p>
      </section>

      {/* Location */}
      <section id="location" className="bg-white py-8 px-6 max-w-screen-md mx-auto">
        <h2 className="text-2xl text-blue-500 mb-4">Location</h2>
        <p className="mb-4 font-sans">Visit us at: <strong>3501 Midway Rd #260, Plano, TX 75093</strong></p>
        <div className="rounded-lg overflow-hidden shadow-md aspect-video">
          <iframe title = "map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3344.3511031710254!2d-96.84327592432604!3d33.047222173551965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c2498cd550c9b%3A0x555e8fd441515567!2sPlanet%20Scrubs!5e0!3m2!1sen!2sus!4v1742425374594!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>

      {/* Hours */}
      <section id="hours" className="bg-white py-8 px-6 max-w-screen-md mx-auto">
        <h2 className="text-2xl text-blue-500 mb-4">Store Hours</h2>
        <div className="font-sans">
          <p>Monday – Thursday: 10:00 AM – 5:30 PM</p>
          <p>Friday: 10:00 AM – 5:00 PM</p>
          <p>Saturday: 10:00 AM – 4:00 PM</p>
          <p>Sunday: Closed</p>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="bg-white py-8 px-6 max-w-screen-md mx-auto">
        <h2 className="text-2xl text-blue-500 mb-4">Contact Us</h2>
        <div className="font-sans">
          <p className="mb-2">Email: <a href="mailto:info@planetscrubs.net" className="text-pink-500 hover:text-blue-500 transition">info@planetscrubs.net</a></p>
          <p>Phone: (972) 378-6505</p>
        </div>
      </section>

      {/* Offers */}
      {false && (
        <section className="py-4 sm:py-8 px-6 text-center">
          <h2 className="text-2xl font-semibold text-blue-500 mb-2">Special Offer</h2>
          <p className="mb-6 text-gray-700">Show this in-store or save a copy:</p>
          <div className="flex flex-col items-center">
            <img
              src="/images/10off_coupon.png"
              alt="10% Off Coupon"
              className="w-72 rounded shadow-md mb-4"
            />
            {typeof window !== 'undefined' && (
              <button
                onClick={() => {
                  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                  if (isMobile) {
                    const link = document.createElement('a');
                    link.href = '/images/10off_coupon.png';
                    link.download = 'PlanetScrubs-10OFF.png';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  } else {
                    const printWindow = window.open('', '_blank');
                    if (printWindow) {
                      printWindow.document.write(`
                  <html>
                    <head>
                      <title>Print Coupon</title>
                      <style>
                        body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; }
                        img { max-width: 100%; height: auto; }
                      </style>
                    </head>
                    <body>
                      <img src="/images/10off_coupon.png" alt="10% Off Coupon" />
                      <script>
                        window.onload = function() {
                          window.print();
                        };
                      </script>
                    </body>
                  </html>
                `);
                      printWindow.document.close();
                    }
                  }
                }}
                className="bg-blue-500 hover:bg-blue-600 text-white px-5 py-2 rounded transition"
              >
                {/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
                  ? 'Save to Photos'
                  : 'Print'}
              </button>
            )}
          </div>
        </section>
      )}

      {/* Inline Subscribe Section */}
      <section className="bg-pink-50 py-8 px-6 max-w-screen-md mx-auto mt-8 rounded-lg shadow">
        <h2 className="text-2xl text-gray-800 mb-2">Join Our Mailing List</h2>
        <p className="text-m text-gray-700 mb-4 font-sans">
          Sign up for a 10% off coupon and exclusive updates on new arrivals and sales.
        </p>

        <form
          onSubmit={async (e) => {
            e.preventDefault();
            setError(null);

            if (!formData.name || !formData.email) {
              setError('Please enter both name and email.');
              return;
            }

            try {
              const res = await fetch('https://planet-scrubs.onrender.com/api/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
              });

              const data = await res.json();

              if (res.ok) {
                setSubmitted(true);
              } else {
                setError(data.error || 'Subscription failed.');
              }
            } catch {
              setError('Network error.');
            }
          }}
          className="space-y-4 font-sans"
        >
          <div>
            <label htmlFor="inline-name" className="block text-sm text-gray-700">Name</label>
            <input
              type="text"
              id="inline-name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-400"
            />
          </div>

          <div>
            <label htmlFor="inline-email" className="block text-sm text-gray-700">Email</label>
            <input
              type="email"
              id="inline-email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-400"
            />
          </div>

          <div>
            <label htmlFor="inline-phone" className="block text-sm text-gray-700">Phone Number</label>
            <input
              type="tel"
              id="inline-phone"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              placeholder="(123) 456-7890"
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-400"
            />
            <p className="text-xs text-gray-500 mt-1">
              Optional: By entering your phone number, you agree to receive promotional texts. You can opt out anytime.
            </p>
          </div>



          {error && <p className="text-red-600 text-sm">{error}</p>}
          {submitted && <p className="text-green-600 text-sm">Thanks! Check your email for a 10% off coupon.</p>}

          <button
            type="submit"
            className="w-full bg-pink-500 hover:bg-pink-600 text-white py-2 rounded font-medium transition"
          >
            Subscribe
          </button>
        </form>
      </section>


      {/* Footer */}
      <footer className="mt-16 text-gray-500 py-6 text-center font-sans">
        <p>&copy; 2026 Planet Scrubs. All rights reserved.</p>
      </footer>

      {/* Subscribe Popup */}
      {showSubscribe && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg overflow-hidden relative sm:flex">
            {/* Optional image */}
            <div className="hidden sm:block sm:w-1/2 bg-cover bg-center" style={{ backgroundImage: "url('/img/model-image.webp')" }}></div>

            {/* Form content */}
            <div className="w-full sm:w-1/2 p-6">
              {/* Close button */}
              <button
                onClick={() => {
                  localStorage.setItem('popupDismissedAt', Date.now().toString());
                  setShowSubscribe(false);
                }}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl font-bold"
                aria-label="Close"
              >
                &times;
              </button>

              <h2 className="text-xl font-semibold text-gray-800 mb-2">Get 10% Off</h2>
              <p className="text-sm font-sans text-gray-600 mb-4">
                Sign up to get 10% off your next in-store purchase, plus early access to exclusive offers and new arrivals.
              </p>

              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  setError(null);

                  if (!formData.name || !formData.email) {
                    setError('Please enter both name and email.');
                    return;
                  }

                  try {
                    const res = await fetch('https://planet-scrubs.onrender.com/api/subscribe', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(formData)
                    });

                    const data = await res.json();

                    if (res.ok) {
                      setSubmitted(true);
                      sessionStorage.setItem('popupDismissed', 'true');
                      setTimeout(() => setShowSubscribe(false), 2500); // optional auto-close
                    } else {
                      setError(data.error || 'Subscription failed.');
                    }
                  } catch {
                    setError('Network error.');
                  }
                }}
                className="space-y-4 font-sans"
              >
                <div>
                  <label htmlFor="name" className="block text-sm text-gray-700">Name</label>
                  <input
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-400"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm text-gray-700">Email</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-400"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm text-gray-700">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    placeholder="(123) 456-7890"
                    className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-400"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    Optional: By entering your phone number, you agree to receive promotional texts. You can opt out anytime.
                  </p>
                </div>



                {error && <p className="text-red-600 text-sm">{error}</p>}
                {submitted && <p className="text-green-600 text-sm">Thanks! Check your email for a 10% off coupon.</p>}

                <button
                  type="submit"
                  className="w-full bg-pink-500 hover:bg-pink-600 text-white py-2 rounded font-medium transition"
                >
                  Continue
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
